import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { NAV_LINKS, GENERAL_DISCLOSURE } from "@/data/siteContent";
import { track } from "@/lib/api";

export default function Footer() {
  const site = useSite();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-navy text-cream" data-testid="site-footer">
      <div className="container-site py-16 md:py-20">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <img src="/assets/logo.png" alt="1907 Insurance Group logo" className="h-16 w-auto rounded-md bg-white p-1.5" />
            <p className="mt-5 text-cream/85 leading-relaxed">
              1907 Insurance Group is an independent insurance agency helping individuals and families compare life
              insurance options and choose coverage with confidence.
            </p>
            <p className="mt-4 text-sm text-cream/70">
              Michael Janas<br />Independent Licensed Life Insurance Agent<br />NPN {site.npn}
            </p>
          </div>

          <div>
            <h2 className="!text-cream text-lg font-semibold font-sans">Contact</h2>
            <ul className="mt-4 space-y-3">
              <li>
                <a href={`tel:${site.phone_href}`} onClick={() => track("phone_click", { location: "footer" })}
                  className="inline-flex items-center gap-2 text-gold-light font-semibold text-lg hover:text-white transition-colors min-h-[44px]"
                  data-testid="footer-phone-link">
                  <Phone className="h-4 w-4" aria-hidden="true" /> {site.phone_display}
                </a>
              </li>
              <li className="text-cream/70 text-sm">{site.states_served_text}</li>
            </ul>
          </div>

          <nav aria-label="Footer navigation">
            <h2 className="!text-cream text-lg font-semibold font-sans">Explore</h2>
            <ul className="mt-4 space-y-1">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-cream/85 hover:text-gold-light transition-colors inline-flex items-center min-h-[40px]"
                    data-testid={`footer-nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/quote" className="text-cream/85 hover:text-gold-light transition-colors inline-flex items-center min-h-[40px]" data-testid="footer-nav-get-a-quote">
                  Get a Quote
                </Link>
              </li>
            </ul>
          </nav>

          <nav aria-label="Legal">
            <h2 className="!text-cream text-lg font-semibold font-sans">Legal & Policies</h2>
            <ul className="mt-4 space-y-1">
              <li><Link to="/privacy" className="text-cream/85 hover:text-gold-light transition-colors inline-flex items-center min-h-[40px]" data-testid="footer-privacy-link">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-cream/85 hover:text-gold-light transition-colors inline-flex items-center min-h-[40px]" data-testid="footer-terms-link">Terms of Use</Link></li>
              <li><Link to="/accessibility" className="text-cream/85 hover:text-gold-light transition-colors inline-flex items-center min-h-[40px]" data-testid="footer-accessibility-link">Accessibility Statement</Link></li>
              <li><Link to="/privacy#do-not-sell" className="text-cream/85 hover:text-gold-light transition-colors inline-flex items-center min-h-[40px]" data-testid="footer-do-not-sell-link">Do Not Sell or Share My Personal Information</Link></li>
            </ul>
          </nav>
        </div>

        <p className="mt-14 border-t border-white/15 pt-8 text-sm leading-relaxed text-cream/70" data-testid="footer-disclosure">
          {GENERAL_DISCLOSURE}
        </p>
        <p className="mt-6 text-sm text-cream/60">
          © {year} 1907 Insurance Group. All rights reserved. Legal and consent language on this site is pending
          review by a qualified insurance compliance professional.
        </p>
      </div>
    </footer>
  );
}
